<script>
  export let steps = [], onStepClick = () => {}, currentStep = 1, disabled = false;
</script>

<style>
  .stepper {
    display: flex;
    max-width: 900px;
    flex: 1 1 100%;
    justify-content: center;
  }
  .stepper__step {
    width: 30%;
    position: relative;
    max-width: 200px;
  }
  .stepper__step-number {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ccc;
    color: #fff;
    font-size: 22px;    
  }

  .disabled .stepper__step-number {
    pointer-events: none;
  }

  .stepper__step:not(.current) .stepper__step-number {
    cursor: not-allowed
  }

  .stepper__step.passed .stepper__step-number {
    cursor: pointer;
  }

  .stepper__step:not(:first-child) > .stepper__step-left {
    height: 4px;
    position: absolute;
    top: 20px;
    transform: translateY(-50%);
    left: 0;
    right: 50%;
    margin-right: 26px;
    background-color: #ccc;
  }
  .stepper__step:not(:last-child) > .stepper__step-right {
    height: 4px;
    position: absolute;
    top: 20px;
    transform: translateY(-50%);
    left: 50%;
    right: 0;
    margin-left: 26px;
    background-color: #ccc;
  }
  .stepper__step.passed > .stepper__step-number,
  .stepper__step.current > .stepper__step-number {
    background-color: #6a35a3;
  }
  .stepper__step.passed > .stepper__step-left,
  .stepper__step.current > .stepper__step-left {
    background-color: #6a35a3;
  }
  .stepper__step.passed > .stepper__step-right {
    background-color: #6a35a3;
  }
  .stepper__step-name {
    margin-top: 12px;
    font-size: 16px;
    hyphens: auto;
  }
  @media (max-width: 480px) {
    .stepper {
      flex-direction: column;
      align-items: center;
      gap: 12px;
    }
    .stepper__step {
      width: auto;
      max-width: fit-content;
    }
    .stepper__step-left, .stepper__step-right {
      display: none;
    }
  }

  @media (max-width: 768px) {
    .stepper__step-name {
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 2px;
      padding-right: 2px;
    }
  }
</style>
<div class="stepper" class:disabled={disabled}>
  {#each steps as step, i}
    <div
      class="stepper__step"
      class:current={currentStep === i}
      class:passed={currentStep > i}
      title={step}
    >
      <div on:click={() => {
          onStepClick(i + 1);
      }}
      class="stepper__step-number">
        {#if currentStep <= i}
          <span>{i + 1}</span>
        {:else}
          <i class="fas fa-check" />
        {/if}
      </div>
      <div class="stepper__step-name">{step}</div>
      {#if step !== 0}
        <div class="stepper__step-left" />
      {/if}
      {#if step !== steps.length - 1}
        <div class="stepper__step-right" />
      {/if}
    </div>
  {/each}
</div>
